export function getExtension(string) {
  if (string && string.length) {
    const parts = string.split('.')
    return parts.length ? parts[parts.length - 1] : null
  }
  return null
}
